import * as React from 'react';
import { useState } from 'react';

/** Redux Packages. */
import { useSelector } from 'react-redux';

/** Material UI Packages. */
import { Box } from '@mui/material';

/** Material UI Icons. */
import AddIcon from '@mui/icons-material/Add';

/** Internal Components. */
import { CustomSkeleton2 } from 'shared/ui/Skeleton';
import { MainDatagrid } from 'shared/ui/Datagrid';
import ThemeButton from 'shared/ui/Button';
import CustomSnackbar from 'shared/ui/CustomSnackbar';

import EditTradePartnerDialog from './EditTradePartnerDialog';
import NewTradePartnerDialog from './NewTradePartnerDialog';
import { TradePartnerDef } from '../../lib/TradePartnerDef';

export default function TradePartner(props) {
    /** Get props from useDataEntry.js. */
    const { loading } = props;

    /** Redux state for trade partner data. */
    const tradePartnerData = useSelector((state) => state.tradePartnerForm);

    /** State for opening and closing the new dialog. */
    const [newOpen, setNewOpen] = useState(false);
    /** State for opening and closing the edit dialog. */
    const [editOpen, setEditOpen] = useState(false);
    /** State for saving selected row info. */
    const [selectedRow, setSelectedRow] = useState(null);

    /** Handler for opening the edit dialog and loading the existing data. */
    const handleEditClick = (row) => {
        setSelectedRow(row);
        setEditOpen(true);
    };

    /** Render loading skeleton if loading is true. */
    if (loading) {
        return <CustomSkeleton2 />;
    }

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                <ThemeButton text={'NEW'} icon={<AddIcon />} width={'62px'} onClick={() => setNewOpen(!newOpen)} />
            </Box>
            <MainDatagrid
                rows={tradePartnerData}
                cols={TradePartnerDef(handleEditClick)}
                showToolbar="GridToolbar"
                loading={loading}
                id_status={false}
            />
            <NewTradePartnerDialog newOpen={newOpen} setNewOpen={setNewOpen} />
            <EditTradePartnerDialog
                editOpen={editOpen}
                setEditOpen={setEditOpen}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
            />
            <CustomSnackbar />
        </>
    );
}
